import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const designCards = [
  {
    src: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20living%20room%20elegant%20cream%20beige%20sofa%20gold%20accents%20sophisticated%20lighting%20Abidjan%20Africa%20interior%20design%20high%20end%20residential%20warm%20ambiance&width=600&height=480&seq=evco_des001&orientation=landscape',
    title: 'Salon Résidentiel',
    tag: 'Résidentiel',
    icon: 'ri-sofa-line',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=master%20bedroom%20luxury%20plush%20velvet%20headboard%20warm%20lighting%20gold%20accents%20neutral%20tones%20elegant%20decor%20high%20end%20Africa%20Abidjan%20beautiful%20interior&width=600&height=480&seq=evco_des002&orientation=landscape',
    title: 'Chambre Principale',
    tag: 'Résidentiel',
    icon: 'ri-hotel-bed-line',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20space%20sophisticated%20minimalist%20furniture%20wood%20gold%20accents%20professional%20workspace%20elegant%20Abidjan%20Ivory%20Coast%20Africa&width=600&height=480&seq=evco_des003&orientation=landscape',
    title: 'Bureau Professionnel',
    tag: 'Commercial',
    icon: 'ri-briefcase-line',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20dining%20room%20round%20marble%20table%20gold%20chairs%20chandelier%20warm%20lighting%20luxury%20Africa%20modern%20interior%20design%20cream%20tones%20beautiful&width=600&height=480&seq=evco_des004&orientation=landscape',
    title: 'Salle à Manger',
    tag: 'Résidentiel',
    icon: 'ri-restaurant-line',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20kitchen%20modern%20design%20marble%20countertop%20gold%20hardware%20elegant%20minimalist%20Africa%20Abidjan%20residential%20high%20end%20contemporary%20style%20warm&width=600&height=480&seq=evco_des005&orientation=landscape',
    title: 'Cuisine Moderne',
    tag: 'Résidentiel',
    icon: 'ri-knife-line',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/f77c5d1e38fb14144dbefad5ae4929ea.jpeg',
    title: 'Hall d\'Entrée',
    tag: 'Commercial',
    icon: 'ri-building-line',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/6094abaae4292c55fce43fa369a6212d.jpeg',
    title: 'Chambre Enfant',
    tag: 'Résidentiel',
    icon: 'ri-heart-line',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/b563d3cf6c03cbec2702fd7be1ae636c.jpeg',
    title: 'Salle de Bain',
    tag: 'Résidentiel',
    icon: 'ri-drop-line',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/19a0cc40440e8fe06cf33e96142b4063.jpeg',
    title: 'Espace Détente Bureau',
    tag: 'Commercial',
    icon: 'ri-community-line',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/4772a2aeee661afe05b2e6b0a5f8d509.jpeg',
    title: 'Terrasse & Extérieur',
    tag: 'Extérieur',
    icon: 'ri-sun-line',
  },
];

const tagColors: Record<string, string> = {
  'Résidentiel': 'bg-brand-fuchsia/10 text-brand-fuchsia',
  'Commercial': 'bg-brand-coral/10 text-brand-coral',
  'Extérieur': 'bg-brand-gold/20 text-brand-anthracite',
};

const BeforeAfterGallery = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-brand-beige py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Notre Portfolio</span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">Nos Designs</h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            Chaque espace est une signature — découvrez nos réalisations résidentielles et commerciales à travers la Côte d&apos;Ivoire.
          </p>
        </div>

        {/* Grid */}
        <div
          ref={ref}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        >
          {designCards.map((card, idx) => (
            <div
              key={card.title}
              className={`group bg-white rounded-2xl overflow-hidden cursor-pointer transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              {/* Image */}
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={card.src}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-brand-anthracite/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* Tag */}
                <div className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${tagColors[card.tag]}`}>
                  {card.tag}
                </div>
              </div>


            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterGallery;
